import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useFAQDocumentDetails } from "@modules/ECMS/MAGP/Forms/FAQ/Faq.hook";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { useCircularDetails, useGeneralDetails } from "../Announcements.hook";
import { fields } from "../constants";

export const AddEditNewCircular = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: Data,
    error,
    isLoading: isLoadingData,
    isError,
    refetch: refectchData,
  } = useCircularDetails(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingDataById,
    refetch: refectchDataById,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refectchDataById();
    }
    if (query.get("editId")) {
      refectchData();
    }
  }, [query.get("editId"), query.get("id")]);

  const faqFormConfig: FormConfig = {
    initialValues: {
      field_title_eng: dataById
        ? decodeHTML(dataById?.payload?.field_title_eng)
        : Data
          ? decodeHTML(Data?.field_title_eng)
          : "",
      field_title_mal: dataById ? decodeHTML(dataById?.payload?.field_title_mal) : Data ? decodeHTML(Data?.field_title_mal) : "",
      field_title_man: dataById
        ? decodeHTML(dataById?.payload?.field_title_man)
        : Data
          ? decodeHTML(Data?.field_title_man)
          : "",
      field_pdfurl: dataById ? decodeHTML([
        {
          uid: "-1",
          name: "field_pdfurl.pdf",
          status: "done",
          url: dataById?.payload?.field_pdfurl,
        },
      ])
    : decodeHTML([
        {
          uid: "-1",
          name: "field_pdfurl.pdf",
          status: "done",
          url: Data?.field_pdfurl
        },
      ]),
      field_date: dataById
        ? decodeHTML(dataById?.payload?.field_date)
        : Data
          ? decodeHTML(Data?.field_date)
          : "",
      field_description_eng: dataById
        ? decodeHTML(dataById?.payload?.field_description_eng?.value)
        : Data
          ? decodeHTML(Data?.field_description_eng)
          : "",
      field_description_mal: dataById ? decodeHTML(dataById?.payload?.field_description_mal?.value) : Data ? decodeHTML(Data?.field_description_mal) : "",
      field_description_man: dataById
        ? decodeHTML(dataById?.payload?.field_description_man?.value)
        : Data
          ? decodeHTML(Data?.field_description_man)
          : "",
      field_circular_published: dataById ? dataById.payload.field_circular_published : Data ? Data.field_circular_published : "",
    },
    fields: fields.circular,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }
    let imageKeys: any = [
      "field_pdfurl"
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "MAGP");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    let publishKey: any=[
      'field_circular_published'
    ]
    for (const key of publishKey) {
      data[key] = !!data[key];
    } 

    let descKeys: any = [
      "field_description_man",
      "field_description_mal",
      "field_description_eng",
    ];
    for (const key of descKeys) {
      try {
        data[key] = {
          value: data[key] || "",
          format: "full_html",
        };
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "ANNOUNCEMENT",
      subModule: "circular",
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...data,
        title: data?.field_title_eng,
        published: true 
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response:any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response:any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refectchDataById();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingDataById}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Circular`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingDataById || isLoadingData}
        config={faqFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${magpHost}/api/circular-creation${(Data?.id || dataById?.payload?.id) ? `/${Data?.id || dataById?.payload?.id}` : ""}`,
            `${query.get("editId") || query.get('type')==='update' ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get('type')==='update' ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
